// 小提示彈窗 複製、收藏、留言
import { useEffect } from 'react';
import Image from 'next/image';

const HintModal = ({ t, dispatch, setShowHintModal, hintText, showHintModal }) => {
    // 關閉彈窗
    const onClose = () => dispatch(setShowHintModal(false));

    useEffect(() => {
        if (showHintModal) setTimeout(() => onClose(), 3000);
    }, [showHintModal]);

    return (
        <div
            className={`fixed trans left-[50%] translate-x-[-50%] translate-y-[-50%] bg-black rounded-[6px]
            px-[30px] py-[12px] flex items-center gap-x-[16px] text-bd4n text-white shadow-[0_0_20px_0_rgba(135,135,135,.25)]
            ${showHintModal ? 'z-[20] opacity-[1] top-[50%]' : 'z-[-1] opacity-0 top-[52%]'}`}
        >
            <Image
                className="!object-contain flex-shrink-0"
                width={37}
                height={37}
                src={`/images/icon/icon_${
                    hintText === 'HINT_INAPPROPRIATE' ? 'error' : 'check'
                }.svg`}
                alt="icon"
            />
            {t(hintText)}
        </div>
    );
};

export default HintModal;
